import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    Row,
    Col,
    Form,
    Button,
    Accordion,
    Card,
    Badge,
} from "react-bootstrap";
import { css } from "aphrodite";
import styles from "../style";
import CustomRadioButton from "../../GenericComponents/CustomRadioButton";
import CustomModal from "../../GenericComponents/CustomModal";
import "./FallDetectionSettings.css";

class FallDetectionSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enableFallDetection: false,
            enableFallEventAlarmRingtone: false,
            enableUpdateFlag: false,
            updateSettings: false,
        };
    }

    componentDidMount = () => {

    };

    handleChanges = (fieldName, value) => {
        let fallDetectionSettings = this.props.fallDetectionSettings;
        fallDetectionSettings[fieldName] = value.target.checked;
        this.setState(
            { enableUpdateFlag: true, [fieldName]: value.target.checked },
            () => {
                this.props.setFallDetectionSettingsData(fallDetectionSettings);
            }
        );
    };

    handleSettingChanges = (fieldName, value) => {
        let fallDetectionSettings = this.props.fallDetectionSettings;
        fallDetectionSettings[fieldName] = value;
        this.setState({ enableUpdateFlag: true, [fieldName]: false }, () => {
            this.props.setFallDetectionSettingsData(fallDetectionSettings);
        });
    };

    saveData = () => {
        this.setState({ updateSettings: !this.state.updateSettings });
    };

    handleUpdate = (fieldName, value) => {
        this.setState({ updateSettings: !this.state.updateSettings }, () => {
            value &&
                this.props.updateFallDetectionSettings(
                    this.props.fallDetectionSettings
                );
        });
    };

    render() {
        const { fallDetectionSettings, appModules, user } = this.props;
        const isReadOnly = user?.roleId === 10;

        return (
            <container>
                <CustomModal
                    header={"Alert"}
                    name={"enableFallDetection"}
                    size={"sm"}
                    title={
                        "Are you sure to enable the Fall Detection"
                    }
                    show={this.state.enableFallDetection}
                    action={this.handleSettingChanges}
                />
                <CustomModal
                    header={"Alert"}
                    name={"enableFallEventAlarmRingtone"}
                    size={"sm"}
                    title={"Are you sure to Enable Alarm Ringtone For Fall Detection"}
                    show={this.state.enableFallEventAlarmRingtone}
                    action={this.handleSettingChanges}
                />
                <CustomModal
                    header={"Confirm"}
                    name={"updateSettings"}
                    size={"sm"}
                    title={"Are you sure you want to save the details ?"}
                    show={this.state.updateSettings}
                    action={this.handleUpdate}
                />
                <div
                    style={{
                        padding: "2em",
                    }}
                >
                    <div className={css(styles.header)}>
                        {"Fall Detection Settings"}
                    </div>
                    {appModules.length !== 0 &&
                        <div>
                            {appModules.active.FD ?
                                <Form>
                                    <Form.Group className={css(styles.formGroupStyles)}>
                                        <Form.Label className={
                                            css(styles.settingLabels)
                                        }>
                                            Enable Fall Detection
                                        </Form.Label>

                                        <CustomRadioButton
                                            name={"enableFallDetection"}
                                            type={"switch"}
                                            inline={true}
                                            label={""}
                                            checked={fallDetectionSettings.enableFallDetection}
                                            action={this.handleChanges}
                                            disabled={isReadOnly}
                                        />
                                    </Form.Group>

                                    <Form.Group className={css(styles.formGroupStyles)}>
                                        <Form.Label
                                            className={
                                                css(styles.settingLabels)
                                            }
                                        >
                                            Enable Alarm Ringtone For Fall Event
                                        </Form.Label>

                                        <CustomRadioButton
                                            name={"enableFallEventAlarmRingtone"}
                                            type={"switch"}
                                            inline={true}
                                            label={""}
                                            checked={fallDetectionSettings.enableFallEventAlarmRingtone}
                                            action={this.handleChanges}
                                            disabled={isReadOnly}
                                        />
                                    </Form.Group>

                                    <div style={{ marginTop: "2em", textAlign: "center" }}>
                                        {!isReadOnly &&
                                            <Button
                                                variant="primary"
                                                type="button"
                                                className={css(styles.updateButtonStyles)}
                                                style={{ marginRight: "10px" }}
                                                disabled={!this.state.enableUpdateFlag}
                                                onClick={() => this.saveData()}
                                            >
                                                Update
                                            </Button>}
                                        <Button
                                            variant="secondary"
                                            type="button"
                                            className={css(styles.updateButtonStyles)}
                                            onClick={() => this.props.closeSettings()}
                                        >
                                            Close
                                        </Button>
                                    </div>
                                </Form>
                                :
                                <div style={{ fontSize: "16px", textTransform: "capitalize", color: "red" }}>
                                    <label>
                                        Not included in your current subscription plan
                                    </label>
                                </div>}
                        </div>
                    }
                </div>
            </container>
        );
    }
}

export default connect(
    (store) => {
        return {
            fallDetectionSettings: store.settings.fallDetectionSettings,
            appModules: store.dashboard.appModules,
            user: store.user
        };
    },
    (dispatch) => {
        return {};
    }
)(withRouter(FallDetectionSettings));
